import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DocumentDto } from '../../beneficiaries/beneficiary-details/documents/document.dto';
import { FileDataDto } from '../../shared/file-input/file-data.dto';
import { ImportService } from '../../shared/services/import.service';
import { ToastService } from '../../shared/toast/toast.service';
import { LogDisplayDto } from './log.diplay.dto';

@Component({
  selector: 'app-admin-import',
  templateUrl: './import.component.html',
})
export class ImportComponent implements OnInit {
  public iodasLogs: LogDisplayDto[];
  public csvLogs: LogDisplayDto[];

  public importCsvForm: FormGroup<{
    fileName: FormControl<string | null>;
  }>;
  public selectedFile: File | undefined;

  public submitted: boolean = false;

  constructor(
    private readonly importService: ImportService,
    private readonly toastService: ToastService,
    private readonly formBuilder: FormBuilder,
  ) {}

  public async ngOnInit(): Promise<void> {
    this.iodasLogs = await this.importService.getIodasLogsList();
    this.csvLogs = await this.importService.getCsvLogsList();

    this.importCsvForm = this.formBuilder.group({
      fileName: new FormControl<string | null>(undefined, [
        Validators.required,
        // Validate mime type of file
        (control: AbstractControl): { [key: string]: any } | null =>
          this.selectedFile &&
          (![
            'text/csv',
            'application/vnd.ms-excel', // Returned by Firefox on Windows for CSV files
          ].includes(this.selectedFile.type) ||
            !this.selectedFile.name.toLocaleLowerCase().endsWith('csv')) // To avoid an Excel file due to previous 'application/vnd.ms-excel' acceptance
            ? { allowedType: { value: control.value } }
            : null,
      ]),
    });
  }

  public onFileChange(files: FileList): void {
    this.selectedFile = files[0];
    this.importCsvForm.controls.fileName.setValue(this.selectedFile.name);
  }

  public async onSubmit(): Promise<void> {
    this.submitted = true;

    if (this.importCsvForm.valid) {
      const fileDataDto: FileDataDto = {
        fileData: await new Promise<string>((resolve: (value: string) => void): void => {
          const reader: FileReader = new FileReader();
          reader.readAsDataURL(this.selectedFile);
          reader.onload = (): void => {
            resolve(reader.result as string);
          };
        }),
      } as DocumentDto;
      if (fileDataDto.fileData) {
        const result: string = await this.importService.importCsv(fileDataDto);
        this.submitted = false;
        this.csvLogs = await this.importService.getCsvLogsList();
        if (result === 'true') {
          this.toastService.show('Import effectué sans erreur', 'success');
        } else {
          this.toastService.show('Import effectué avec des erreurs', 'warning');
        }
      }
    }
  }

  public async download(id: number, filename: string): Promise<void> {
    this.importService.downloadLog(id, filename);
  }
}
